// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C9cs","footer":"styles_footer__362g8"};